import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import './side-drawer.scss';
import Backdrop from '../../ui-elements/backdrop/backdrop';
import useHasMounted from '../../../../hooks/client-only-hook';

var SideDrawer = function SideDrawer(_ref) {
  var show = _ref.show,
      onCancel = _ref.onCancel,
      children = _ref.children;
  var hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  var content = /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(Backdrop, {
    onClick: onCancel
  }), /*#__PURE__*/React.createElement(CSSTransition, {
    in: show,
    timeout: 300,
    classNames: "slide",
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("aside", {
    className: "side-drawer",
    onClick: onCancel,
    onKeyDown: onCancel // dealt with "jsx-a11y/click-events-have-key-events"
    ,
    role: "presentation" // dealt with "jsx-a11y/no-noninteractive-element-interactions"

  }, children)));
  return /*#__PURE__*/ReactDOM.createPortal(content, document.getElementById('drawer-hook'));
};

export default SideDrawer;